<template>
  <div id="mainPage">
    <header>
      <HeaderSpecial />
      <BreadcrumbList />
    </header>
    <div id="main">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide"
               v-for="spcecialExhibition in virtualData.slides"
               :key="spcecialExhibition.id"
               :style="slideStyles"
          >
            <section class="artwork">
              <div class="inner2">
                <div class="client"><p class="clientTitle">特別展示</p><p class="titleSub">Special Exhibition</p></div>
                <div class="clientName">
                  <img class="clientLogo" :src="spcecialExhibition.logoUrl" :srcset="get2xLogoUrl(spcecialExhibition.logoUrl)" alt="" />
                  <h1 class="cNameTxt">{{spcecialExhibition.name}}</h1>
                </div>
              </div><!-- /inner2-->

              <div v-if="spcecialExhibition && (spcecialExhibition.description || spcecialExhibition.youtubeUrl || spcecialExhibition.voice)" class="exhCommentary">
                <div class="exhCommentaryBody" style="overflow: auto;">
                  <div class="inner2" >
                    <div v-if="isCommentExists(spcecialExhibition)" class="expTxt">
                      <p :class="{zeroPaddingRight: !spcecialExhibition.youtubeUrl && !spcecialExhibition.voice}">{{spcecialExhibition.description}}</p>
                    </div>
                    <div v-if="isVoiceExists(spcecialExhibition)" class="expMovie">
                      <audio
                        v-if="spcecialExhibition && spcecialExhibition.voice"
                        class="my-1"
                        controls
                        :src="spcecialExhibition.voice">
                        音声再生がサポートされていないブラウザです。
                      </audio>
                    </div>
                    <div v-if="isMovieExists(spcecialExhibition)" class="expMovie">
                      <iframe width="320" height="180" :src="convertYoutubeUrl(spcecialExhibition.youtubeUrl)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                  </div><!-- /inner-->
                </div><!-- /exhCommentaryBody-->
              </div><!-- /exhCommentary-->
              <!-- photowall special Exhibitions -->
              <PhotoWallSpecial v-if="specialExhibitionById(spcecialExhibition.id)" :spcecialExhibition="specialExhibitionById(spcecialExhibition.id)" :openImageViewer="openImageViewer" />
            </section>
            <section class="relatedInfo">
              <div class="inner2">
                <h3>関連情報</h3>
                <div class="relatedfTxt">
                  <span v-html="spcecialExhibition.infomation"></span>
                </div>
                <p v-if="spcecialExhibition && spcecialExhibition.link1Url" class="relatedLink">
                  <a :href="spcecialExhibition.link1Url" target="_blank" rel="noopener noreferrer">{{spcecialExhibition.link1Text}}</a>
                </p>
                <p v-if="spcecialExhibition && spcecialExhibition.link2Url" class="relatedLink">
                  <a :href="spcecialExhibition.link2Url" target="_blank" rel="noopener noreferrer">{{spcecialExhibition.link2Text}}</a>
                </p>
              </div><!-- /inner-->
            </section><!-- /message-->
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isDemo()" class="cursorRight" :class="{ cursorDisable: this.currentIndex == (this.specialExhibitions.length - 1) }">
      <a href="javascript:void(0);" @click="moveNext" :class="{ cursorDisable: this.currentIndex == (this.specialExhibitions.length - 1) }">
        <img src="/img/arwRight.png" srcset="/img/arwRight@2x.png" style="filter: blur(0px)"/>
      </a>
    </div>
    <div v-if="!isDemo()" class="cursorLeft" :class="{ cursorDisable: this.currentIndex == 0 }">
      <a href="javascript:void(0);" @click="movePrev" :class="{ cursorDisable: this.currentIndex == 0 }">
        <img src="/img/arwLeft.png" srcset="/img/arwLeft@2x.png" style="filter: blur(0px)" />
      </a>
    </div>
    <MessageDialog :isOpen.sync="isMessageOpen" :title="messageTitle" :text="messageText" />
    <Footer />
    <ImageViewerSpecial
      :isOpen.sync="isImageViewerOpen"
      :specialExhibition="currentSpecialExhibition"
      :specialExhibitionWork="currentSpecialExhibitionWork"
      :commentaryType="commentaryType"
    />
    <UpButton />
    <QuestionnaireButton />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderSpecial from '@/components/modules/HeaderSpecial.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import Footer from '@/components/modules/Footer.vue'
import ImageViewerSpecial from '@/components/modules/ImageViewerSpecial.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import Swiper from 'swiper/bundle'
import MessageDialog from '@/components/modules/MessageDialog.vue'
import sanitizeHtml from 'sanitize-html'
import AutoLinkUtil from '@/util/AutoLinkUtil'
import YoutubeUtil from '@/util/YoutubeUtil'
import PhotoWallSpecial from '@/components/modules/photoWall/PhotoWallSpecial.vue'
import UpButton from '@/components/modules/UpButton.vue'
import QuestionnaireButton from '@/components/modules/QuestionnaireButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    HeaderSpecial,
    Footer,
    ImageViewerSpecial,
    BreadcrumbList,
    MessageDialog,
    PhotoWallSpecial,
    UpButton,
    QuestionnaireButton
  },
  data () {
    return {
      swiper: null,
      isImageViewerOpen: false,
      commentaryType: '',
      currentIndex: 0,
      currentSpecialExhibition: { id: null },
      currentSpecialExhibitionWork: null,
      slides: [],
      virtualData: {
        slides: []
      },
      isSpecialExhibitionIntroductionClose: {},
      isMessageOpen: false,
      messageTitle: '',
      messageText: '',
      currentScrollPosition: 0
    }
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    // イメージビュワー表示
    openImageViewer (SpecialExhibitionWork, commentaryType = null) {
      if (!SpecialExhibitionWork) {
        return
      }
      // モーダルダイアログを表示する際にはメインページ（背景ページ）のスクロールを固定する
      this.bodyFixedOn()

      this.currentSpecialExhibition = this.specialExhibitionById(SpecialExhibitionWork.exhibitorId)
      this.currentSpecialExhibitionWork = SpecialExhibitionWork
      this.commentaryType = commentaryType
      this.isImageViewerOpen = true

      // 個別画像ページへURL書き換え
      const path = `/specials/${this.currentSpecialExhibition.id}/images/${SpecialExhibitionWork.id}`
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
    },
    // メインページスクロール固定処理設定
    bodyFixedOn () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        this.currentScrollPosition = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.currentScrollPosition}px`
      } else {
        body.style.overflow = 'hidden'
      }
    },
    // メインページスクロール固定処理解除
    bodyFixedOff () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        body.style.removeProperty('position')
        body.style.removeProperty('top')
        window.scrollTo(0, this.currentScrollPosition)
      } else {
        body.style.removeProperty('overflow')
      }
    },
    // スワイプ移動イベント
    slideChange (event) {
      this.currentIndex = event.activeIndex
      this.currentSpecialExhibition = this.specialExhibitions[event.activeIndex]
      const path = `/specials/${this.specialExhibitions[event.activeIndex].id}`
      // 移動先のパスが現在と違うこと、かつ、winningWorkIdパラメータで詳細画面が指定されていない場合は、URL書き換え
      if (path !== this.$route.path && !this.$route.params.specialExhibitionsWorkId) {
        this.$router.push(path)
      }
    },
    // URLから特定のslideを表示するメソッド
    moveSlideByUrl () {
      // スライド移動
      if (this.specialExhibitionsIndexById(this.$route.params.id) !== this.swiper.activeIndex) {
        this.swiper.slideTo(this.specialExhibitionsIndexById(this.$route.params.id), 500, false)
        this.currentIndex = this.specialExhibitionsIndexById(this.$route.params.id)
        this.currentSpecialExhibition = this.specialExhibitionById(this.$route.params.id)
      }
    },
    // 右へswipe
    moveNext () {
      if (this.currentIndex >= this.specialExhibitions.length - 1) {
        return
      }
      this.swiper.slideTo(this.currentIndex + 1, 500, false)
    },
    // 左へswipe
    movePrev () {
      if (this.currentIndex <= 0) {
        return
      }
      this.swiper.slideTo(this.currentIndex - 1, 500, false)
    },
    changeCommentaryMode (value) {
      this.$set(this.isSpecialExhibitionIntroductionClose, this.currentSpecialExhibition.id, value)
    },
    sanitizeAndAutoLink (str) {
      return AutoLinkUtil.convert(sanitizeHtml(str, { allowedTags: false }))
    },
    isCommentExists (specialExhibition) {
      return (
        specialExhibition && specialExhibition.description
      )
    },
    isMovieExists (specialExhibition) {
      return (
        specialExhibition && specialExhibition.youtubeUrl
      )
    },
    isVoiceExists (specialExhibition) {
      return (
        specialExhibition && specialExhibition.voice
      )
    },
    convertYoutubeUrl (url) {
      return YoutubeUtil.getEmbedUrl(url)
    },
    getSpecialExhibitionsWorkByPath (path) {
      const pathList = path.split('/')
      if (pathList && pathList.length >= 4) {
        return this.specialExhibitionById(pathList[3])
      }
      return null
    },
    get2xLogoUrl (logoUrl) {
      return logoUrl.replace('.jpg', '@2x.jpg 2x')
    },
    getSpecialExhibitionsWorkById (specialExhibition, workId) {
      for (const specialExhibitionWork of specialExhibition.specialExhibitionWorks) {
        if (specialExhibitionWork.id === workId) {
          return specialExhibitionWork
        }
      }
    },
    setTitleAndDescription (to) {
      const specialExhibition = this.specialExhibitionById(to.params.id)
      if (!specialExhibition) return
      // titleの設定
      let pageTitle = ''
      if (to.params.specialExhibitionsWorkId) {
        // 作品画像詳細の場合
        const specialExhibitionsWork = this.getSpecialExhibitionsWorkById(specialExhibition, to.params.specialExhibitionsWorkId)
        if (!specialExhibitionsWork) return
        pageTitle = `${specialExhibition.name}「${specialExhibitionsWork.title}」`
      } else {
        // 出展者の場合
        pageTitle = `${specialExhibition.name}`
      }
      document.title = pageTitle + (to.meta.title ? to.meta.title : '')
      // descriptionの設定
      const pageDescription = ''
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : '') + pageDescription)
    }
  },
  computed: {
    ...mapGetters([
      'specialExhibitions',
      'specialExhibitionsIndexById',
      'specialExhibitionById',
      'tsvLoadCompleteFlag'
    ]),
    slideStyles () {
      return `left: ${this.virtualData.offset}px`
    }
  },
  created () {
  },
  mounted () {
    // swiper初期設定
    const self = this
    this.swiper = new Swiper('.swiper-container', {
      shortSwipes: true,
      noSwiping: true,
      noSwipingSelector: '.notSwipe,input,textarea,.msgPstArea' + (this.isDemo() ? ',body' : ''),
      virtual: {
        slides: this.specialExhibitions,
        renderExternal (data) {
          self.virtualData = data
        }
      },
      on: {
        slideChange: this.slideChange
      }
    })
    // vuexへの読み込み状態を監視し、読み込まれたら表示を更新する
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setTsvCompleteFlag') {
        if (!this.tsvLoadCompleteFlag) return
        this.swiper.virtual.appendSlide(this.specialExhibitions)

        // またURLの指定された位置を検知にswiperを適切なindex番号に遷移させる
        this.swiper.slideTo(this.specialExhibitionsIndexById(this.$route.params.id), 0, false)

        // 現在位置情報を保持
        this.currentIndex = this.specialExhibitionsIndexById(this.$route.params.id)
        this.currentSpecialExhibition = this.specialExhibitionById(this.$route.params.id)

        // 存在しないURLが指定されていた場合Not Foundに遷移
        // 読み込み完了までにタイムラグがあるため、setTimeoutで実行
        setTimeout(() => {
          // 出展者が存在しない場合
          if (!this.specialExhibitionById(this.$route.params.id)) {
            this.$router.push('/notFound')
          }
        }, 300)

        // 画像ビュワー表示判定
        // winningWorkIdが指定されているのにもかかわらず、画像個別ウインドウが表示されていなければ表示
        if (this.$route.params.specialExhibitionsWorkId && !this.isImageViewerOpen) {
          let specialExhibitionsWork = null
          if (this.currentSpecialExhibition) {
            for (const sWork of this.currentSpecialExhibition.specialExhibitionWorks) {
              if (String(sWork.id) === this.$route.params.specialExhibitionsWorkId) {
                specialExhibitionsWork = sWork
                break
              }
            }
          }
          // 作品が存在しない場合
          if (!specialExhibitionsWork) {
            this.bodyFixedOff()
            this.$router.push('/notFound')
            return
          }

          this.openImageViewer(specialExhibitionsWork)
        }

        // titleとdescriptionの設定
        this.setTitleAndDescription(this.$route)
      }
    })
    this.moveSlideByUrl()
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    // モーダルウインドウが閉じられたらメインページのスクロールができるようにする
    isImageViewerOpen: function (val, oldVal) {
      if (!val) {
        this.bodyFixedOff()
      }
    },
    // モーダルウインドウが閉じられたらメインページのスクロールができるようにする
    isPortfolioViewerOpen: function (val, oldVal) {
      if (!val) {
        this.bodyFixedOff()
      }
    },
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    },
    '$route.path': function (val, oldVal) {
      this.moveSlideByUrl()

      // 旧URLに /images/ が無く、新URLに /images/ があった場合（戻るボタンで戻ってきた場合）かつ未だウインドウがopenされてない場合、ウインドウをopen
      const index = val.indexOf('/images/')
      const oldIndex = oldVal.indexOf('/images/')
      if (oldIndex < 0 && index >= 0 && !this.isImageViewerOpen) {
        const specialExhibitionsWork = this.getSpecialExhibitionsWorkByPath(this.$route.path)
        if (specialExhibitionsWork) {
          this.openImageViewer(specialExhibitionsWork) // 表示
        }
      }
    }
  }
}
</script>

<style scoped>
@import '~swiper/swiper-bundle.css';

.imgArtwork {
  width: 250px;
  height: 250px;
  object-fit: contain;
}

.cursorRight {
  width: 42px;
  height: 44px;
  position: fixed;
  right: 8px;
  top:calc(50% - 88px/2);
  z-index: 2000;
}

.cursorLeft {
  width: 42px;
  height: 44px;
  position: fixed;
  left: 8px;
  top:calc(50% - 88px/2);
  z-index: 2000;
}

.cursorDisable {
  opacity: 0.5;
  cursor: default;
}

@media screen and ( max-width:640px) {
  .cursorRight {
    width: 28px;
    height: 29px;
    right: 4px;
  }
  .cursorLeft {
    width: 28px;
    height: 29px;
    left: 4px;
  }
}
.zeroPaddingRight{
  padding-right: 0 !important;;
}
.commentaryHeight {
  transition: all 0.5s;
  opacity: 1;
  height: 250px;
}

.hideCommentary {
  height: 0px;
  opacity: 0;
}
</style>
